import { render, staticRenderFns } from "./DunningLetterJobs.yaml?vue&type=template&id=f4903282&component"
import script from "./DunningLetterJobs.yaml?vue&type=script&lang=ts&component"
export * from "./DunningLetterJobs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports